module.exports = __webpack_public_path__ + "img/banner-swiper2.385cde50.png";